import React from "react"

const Comments = ({}) => {
  return (
    <div className="comments-wrapper section-inner">
      {/* TODO */}

      {/*<div id="respond" className="comment-respond">*/}
      {/*    <h2 id="reply-title" className="comment-reply-title">Leave a Reply <small><a rel="nofollow"*/}
      {/*                                                                                 id="cancel-comment-reply-link"*/}
      {/*                                                                                 href="/page-1/#respond"*/}
      {/*                                                                                 style={{display: "none"}}>*/}
      {/*        Cancel reply</a></small></h2>*/}
      {/*    <form action="https://henrik-thesis-10.local/wp-comments-post.php" method="post"*/}
      {/*          id="commentform" className="section-inner thin max-percentage" noValidate=""><p*/}
      {/*        className="logged-in-as"><a href="https://henrik-thesis-10.local/wp-admin/profile.php"*/}
      {/*                                    aria-label="Logged in as Henrik Wirth. Edit your profile.">Logged*/}
      {/*        in as Henrik Wirth</a>. <a*/}
      {/*        href="https://henrik-thesis-10.local/wp-login.php?action=logout&amp;redirect_to=https%3A%2F%2Fhenrik-thesis-10.local%2Fpage-1%2F&amp;_wpnonce=7b0e97dd5a">Log*/}
      {/*        out?</a></p><p className="comment-form-comment"><label htmlFor="comment">Comment</label>*/}
      {/*        <textarea id="comment" name="comment" cols="45" rows="8" maxLength="65525"*/}
      {/*                  required="required"/></p><p className="form-submit"><input name="submit"*/}
      {/*                                                                             type="submit"*/}
      {/*                                                                             id="submit"*/}
      {/*                                                                             className="submit"*/}
      {/*                                                                             value="Post Comment">*/}
      {/*        <input type="hidden" name="comment_post_ID" value="802" id="comment_post_ID">*/}
      {/*            <input type="hidden" name="comment_parent" id="comment_parent" value="0"/>*/}
      {/*    </p><input type="hidden" id="_wp_unfiltered_html_comment_disabled"*/}
      {/*               name="_wp_unfiltered_html_comment" value="f9d9ece279">*/}
      {/*        <script>(function(){if(window===window.parent){document.getElementById('_wp_unfiltered_html_comment_disabled').name='_wp_unfiltered_html_comment';}})();</script>*/}
      {/*    </form>*/}
      {/*</div>*/}
      {/* #respond */}
    </div>
  )
}

export default Comments
